// removed by extract-text-webpack-plugin
module.exports = {"loginPage":"_29OrYvfMUhaO3hHqqWg6A_","centerScreen":"_1MrBNPlDVnMYGAMcY-tpTa","header":"_1kxmP_3f1FLnu3tQnxalCa","loginForm":"_2Reci4WGhBw4sPHZ5OF2bk","textCenter":"_2nINasjgBMVWuwl8jIjt7m"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/Login.scss
// module id = 797
// module chunks = 0